import cn from 'bem-cn';

import { useImageLoad } from '../../../hooks';

import { BackgroundImageProps } from './BackgroundImage.types';
import './BackgroundImage.scss';

const b = cn('background-image');

export const BackgroundImage = (props: BackgroundImageProps) => {
    const { image, mainColor, className } = props;

    const isLoaded = useImageLoad(image);

    return (
        <div
            className={b({ loaded: isLoaded }).mix(className)}
            style={
                {
                    '--bg-image': image ? `url(${image})` : 'none',
                    '--image-main-color': mainColor,
                } as React.CSSProperties
            }
        >
            <div className={b('dark-overlay')} />
        </div>
    );
};
